import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldWidthEnum } from '@data/cer-data-types';

export class FinanceProjectTransForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet());
  }

  private viewGet(): CerFormView {
    const filterNum = this.routeOptions.navigation?.columnNameChild == 'projectNum';    

    const view = new CerFormView();

    view.viewMetadata = {
      name: 'project-trans', dataApiName: 'FinanceProjectTrans',
      primaryKey: 'id', titleFields: ['project','date','voucher'], baseFields: ['id'],
      allowCreate: false, allowEdit: false, allowDelete: false,
      navigations: [{ link: 'nav', foreignKey: {entity: 'voucher', column: 'voucherNum', parentColumn: 'voucher'}}]
    };

    view.fieldMetadata = [
      { name: 'projectNum', text: 'Projekt', foreignKeyType: 'financeProject'},
      { fieldType: 'transDate', orderBy: 'Descending' },
      { name: 'voucher', text: 'Bilag', format: 'Integer' },
      { name: 'transId', text: 'Transaktio', format: 'Integer', visible: false },
      { name: 'category', text: 'Art', foreignKeyType: 'financeProjectCostType', widthType: FieldWidthEnum.XL },
      { name: 'txt', text: 'Tekst', widthType: FieldWidthEnum.XXL },
      { name: 'amountCost', text: 'Beløb', format: 'Amount' },
      { name: 'amountCostPL', text: 'Beløb res', format: 'Amount', visible: false },
      { name: 'amountCostBalance', text: 'Beløb balance',  format: 'Amount' },
      { name: 'accountCostPL', text: 'Konto omk.', foreignKeyType: 'financeLedgerAccount', foreignKeyValue: 'numName' },
      { name: 'accountCostBalance', text: 'Konto balance' /*, foreignKeyType: 'financeLedgerAccount', foreignKeyValue: 'numName'*/ },
      { name: 'accountOffset', text: 'ModKonto'/*, foreignKeyType: 'financeLedgerAccount', foreignKeyValue: 'numName'*/ }
    ];

    if (filterNum) {
      const sumFields = ['amountCost','amountCostPL','amountCostbalance'];
      view.fieldMetadata.filter(f => sumFields.includes(f.name)).forEach(f => f.footerType = 'Sum');
   }

    return view;
  }
}
